export const HOURS = Array.from({ length: 24 }, (_, i) =>
  String(i).padStart(2, "0")
);
export const MINUTES = Array.from({ length: 60 }, (_, i) =>
  String(i).padStart(2, "0")
);

export const ITEM_HEIGHT = 36;

export function parseTime(value?: string): {
  hours: string;
  minutes: string;
} {
  if (!value) return { hours: "00", minutes: "00" };
  const [h, m] = value.split(":");
  return {
    hours: (h ?? "00").padStart(2, "0"),
    minutes: (m ?? "00").padStart(2, "0"),
  };
}

export function formatTime(hours: string, minutes: string): string {
  return `${hours}:${minutes}`;
}
